module.exports = require("core-js/modules/esnext.set.add-all.js");